import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useScreenContext } from "../Layout";

function TimeSaved() {
  const { t } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: t("layout.cta_continue"),
      nextPath: "topics",
      progress: 49,
    }));
  }, []);

  return (
    <div>
      <h1 className="mb-4 mt-5 text-3xl font-semibold leading-tight tracking-normal text-gray-900 dark:text-white md:text-5xl lg:text-6xl">
        {t("time_saved.headline.part_1")}{" "}
        <span className="font-bold text-blue-600">
          {t("time_saved.headline.part_2")}
        </span>{" "}
        {t("time_saved.headline.part_3")}
      </h1>
    </div>
  );
}

export default TimeSaved;
